import React, { createContext, useContext } from 'react';
import type { Session } from '../api/auth';

interface AuthContextValue {
  session: Session;
}

const AuthContext = createContext<AuthContextValue | null>(null);

interface AuthProviderProps {
  session: Session;
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ session, children }) => (
  <AuthContext.Provider value={{ session }}>
    {children}
  </AuthContext.Provider>
);

export const useAuth = (): AuthContextValue => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
